module.exports = __webpack_public_path__ + "static/media/5.77517726.jpg";